module.exports = __webpack_public_path__ + "media/images/photos/15-666ed943d2b27f6250c49af0569c9038.jpg";